"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormMapping = exports.normalizeFormURL = exports.formHash = void 0;
const flat_1 = require("flat");
const _ = require("lodash");
const whatwg_url_1 = require("whatwg-url");
const md5_1 = require("./md5");
const formHash = (form) => {
    return (0, md5_1.default)(_.keys((0, flat_1.flatten)(form)).sort().join(","));
};
exports.formHash = formHash;
const normalizeFormURL = (originalUrl) => {
    const url = new whatwg_url_1.URL(originalUrl);
    url.search = "";
    url.search = "";
    url.hash = "";
    return url.href;
};
exports.normalizeFormURL = normalizeFormURL;
function getFormMapping(allFormMappings, hash, normalizedFormURL) {
    return _.find(allFormMappings, (mapping) => {
        // if we have mapped a from like this
        if (mapping.formHash === hash) {
            // and this mapping applies to all pages
            if (mapping.applyMappingAcrossPages) {
                return true;
            }
            // applying this mapping to only pages of the same url
            // check if this form url is the same
            if (normalizedFormURL === mapping.url) {
                return true;
            }
        }
        // otherwise this mapping doesn't apply
        return false;
    });
}
exports.getFormMapping = getFormMapping;
//# sourceMappingURL=formTracking.js.map